module.exports = __webpack_public_path__ + "static/media/lk.3e9389bb.svg";